import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput, FormSelect, FormTextarea } from '@/_components';
import { SelectorWithAvatarContainer } from '@/_containers';
import { AsyncCompanySelector } from '@/_pages/companies/shared';
import { BrandsAsyncSelect } from '@/_pages/settings/brands/shared';
import { nameResolver } from '@/_shared';

import { authenticationTypeOptions } from './authentication-type';

import type { ConnectedAppFormSchema } from '../schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<ConnectedAppFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="service_name"
        render={({ field: { value, onChange } }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-6"
            label="Service Name (required)"
            value={value}
            onChange={onChange}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="authentication_type"
        render={({ field: { value, onChange } }) => (
          <FormSelect
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-6"
            label="Authentication Type (required)"
            value={value}
            onChange={onChange}
            disabled={!isEditable}
            options={authenticationTypeOptions}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.value}
          />
        )}
      />

      <div className={'col-span-12 sm:col-span-6 lg:col-span-6'}>
        <FormField
          control={form.control}
          name="brand"
          render={({ field: { value, onChange } }) => (
            <SelectorWithAvatarContainer
              disabled={!isEditable}
              src={value?.icon?.at(0)?.url || ''}
              label={nameResolver(value?.name, undefined, 'Brand')}
              name={value?.name ?? ''}
              className="lg:flex-row"
            >
              <BrandsAsyncSelect disabled={!isEditable} label="Brand" value={value} onValueChange={onChange} />
            </SelectorWithAvatarContainer>
          )}
        />
      </div>

      <div className={'col-span-12 sm:col-span-6 lg:col-span-6'}>
        <FormField
          control={form.control}
          name="legal_entity"
          render={({ field: { value, onChange } }) => (
            <SelectorWithAvatarContainer
              disabled={!isEditable}
              src={value?.logo?.at(0)?.url || ''}
              label={nameResolver(value?.name, undefined, 'Legal Entity')}
              name={value?.name ?? ''}
              className="lg:flex-row"
              avatarClassName="w-14 rounded-md"
            >
              <AsyncCompanySelector
                disabled={!isEditable}
                label="Legal Entity"
                value={value}
                onValueChange={onChange}
              />
            </SelectorWithAvatarContainer>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name="description"
        render={({ field: { value, onChange } }) => (
          <FormTextarea
            formItemClassName="col-span-12"
            label="Description"
            value={value}
            onChange={onChange}
            disabled={!isEditable}
          />
        )}
      />
    </>
  );
}
